<template>
  <div class="py-5">
    <splide
      :options="splideOptions"
      :key="splideComponentKey"
      v-if="bannerCampaigns.length"
      ref="splide"
    >
      <template v-for="(campaign, i) in bannerCampaigns">
        <li
          class="splide__slide"
          :key="`bannerCampaigns-${i}`"
          @click="toCampaign(i, campaign)"
        >
          <div class="image-block">
            <img :src="`${campaign.picBigBanner}`" alt="" />
          </div>
        </li>
      </template>
    </splide>

    <v-sheet
      v-else
      :height="
        $vuetify.breakpoint.xs ? 195 : $vuetify.breakpoint.sm ? 300 : 400
      "
      width="100%"
      color="#d0d8db"
      class="text-center"
    >
      <v-progress-circular
        :width="3"
        color="primary-1"
        indeterminate
        style="margin-top: 54px"
      ></v-progress-circular>
    </v-sheet>

    <CustomRow>
      <CustomCard class="pa-3 pa-md-6">
        <v-text-field
          class="search-input"
          v-model="keyword"
          :label="$t('search_compaign_label')"
          outlined
          color="primary-1"
          hide-details
          @click:append="doSearch"
          @keyup.enter="doSearch"
          large
          clearable
        >
          <template v-slot:append>
            <v-icon class="cursor-pointer" @click="doSearch" color="primary-1"
              >mdi-magnify</v-icon
            >
          </template>
        </v-text-field>
      </CustomCard>
      <CustomCard
        class="border-radius-rwd pa-3 pa-md-6"
        v-if="loadingNewsFinish && !!news && news.length"
      >
        <template v-slot:title>
          <h3 :class="$vuetify.breakpoint.xs ? 'text-title' : 'text-big-tile'">
            {{ $t("index_bulletin") }}
          </h3>
        </template>
        <template v-if="loadingNewsFinish">
          <div class="my-5">
            <template class="mt-5" v-for="(announcement, i) in news">
              <v-hover v-slot="{ hover }" :key="`news-${i}`">
                <div
                  class="py-3 px-0 text-left announcement-item cursor-pointer"
                  :class="{ 'd-flex': !$vuetify.breakpoint.xs }"
                  @click="toNews(announcement)"
                >
                  <span
                    v-if="
                      !$vuetify.breakpoint.xs &&
                      !$vuetify.breakpoint.sm &&
                      announcement.type
                    "
                    style="white-space: nowrap"
                    >【{{ announcement.type }}】</span
                  >
                  <span
                    :class="{
                      'announcement-title': !$vuetify.breakpoint.xs,
                    }"
                    class="mr-2"
                  >
                    {{ announcement.title }}
                  </span>

                  <span class="primary-1--text" style="flex: none">
                    more
                    <v-icon
                      color="primary-1"
                      class="mb-1"
                      :class="{ 'mr-n1 ml-1': hover }"
                      >mdi-chevron-right</v-icon
                    >
                  </span>
                </div>
              </v-hover>
              <div class="red-dash-divider" :key="i + 5"></div>
            </template>
          </div>
          <div class="text-center mt-4 mt-md-6">
            <v-btn
              depressed
              class="d-block mb-0"
              color="primary-1--text"
              width="100%"
              large
              @click="toNewsList"
            >
              {{ $t("index_more_bulletin") }}
            </v-btn>
          </div>
        </template>
        <template v-else>
          <ProgressCircular />
        </template>
      </CustomCard>
      <div class="mt-5 d-flex">
        <div
          class="cus-tab left-tab cursor-pointer text-regular text-sm-big-title"
          :class="{
            inactive: tabSelect !== 1,
          }"
          @click="tabSelect = 1"
        >
          {{ $t("index_hot") }}
        </div>
        <div
          class="cus-tab right-tab cursor-pointer text-regular text-sm-big-title"
          :class="{
            inactive: tabSelect !== 2,
          }"
          @click="tabSelect = 2"
        >
          {{ $t("index_coming") }}
        </div>
      </div>
      <div class="tab-content pa-3 pa-md-6">
        <template v-if="loadingCampaignsFinish">
          <div v-if="campaigns.length">
            <ListActivity :campaigns="campaigns" />
          </div>
          <v-sheet
            v-else
            class="text-center text-h5"
            height="200"
            style="line-height: 200px"
          >
            {{ $t("index_stay_tuned") }}
          </v-sheet>
        </template>
        <template v-else>
          <div class="text-center">
            <ProgressCircular />
          </div>
        </template>
      </div>
    </CustomRow>
  </div>
</template>

<script>
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import ListActivity from "@/views/components/ListActivity.vue";
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import { getNews, getMainEvents } from "@/api/static";
import { redirectToIndex } from "@/shared/redirectToIndex";
import { mapActions } from "vuex";

export default {
  components: { Splide, SplideSlide, ListActivity },
  data() {
    const dt = new Date();
    const timeString = `${dt.getFullYear()}/${
      dt.getMonth() + 1
    }/${dt.getDate()} ${dt.getHours()}:${dt.getMinutes()}`;
    return {
      keyword: "",
      splideComponentKey: 0,
      splideOptions: {
        type: "loop",
        height: `${
          window.innerWidth > 800 ? 500 : window.innerWidth * 0.9 * 0.625
        }px`,
        fixedWidth: "800px",
        gap: "0px",
        cover: true,
        autoplay: true,
        arrows: !this.$vuetify.breakpoint.xs,
        interval: 7000,
        focus: "center",
        breakpoints: {
          960: {
            height: "500px",
            fixedWidth: "800px",
          },
          800: {
            height: "375px",
            fixedWidth: "600px",
          },
          600: {
            height: "214px",
            fixedWidth: "343px",
          },
        },
      },
      bannerCampaigns: [],
      loadingNewsFinish: false,
      news: [],
      tabSelect: 1,
      topCampaigns: [],
      commingSoonCampaigns: [],
      loadingCampaignsFinish: false,
      allEventMainPageInfo: null,
    };
  },
  metaInfo() {
    return {
      title: this.$t("app_name"),
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: this.$t("app_name"),
            url: window.location.origin + window.location.pathname,
          },
        },
      ],
      meta: [
        {
          property: "og:title",
          content: `${this.$t("app_name")}`,
          template: (chunk) => `${chunk}`,
          vmid: "og:title",
        },
        {
          property: "og:url",
          content: window.location.origin + window.location.pathname,
          vmid: "og:url",
        },
        {
          property: "og:img",
          content: "https://ticketplus.com.tw/image/Ticket_PLUS_og.png",
          vmid: "og:img",
        },
        {
          property: "og:image",
          content: "https://ticketplus.com.tw/image/Ticket_PLUS_og.png",
          vmid: "og:image",
        },
      ],
    };
  },
  computed: {
    campaigns() {
      return this.tabSelect === 1
        ? this.topCampaigns
        : this.commingSoonCampaigns;
    },
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      setAllEvent: "event/setAllEvent",
    }),
    doSearch() {
      console.log("keyword", this.keyword);
      let result = [];
      for (var id in this.allEventMainPageInfo) {
        const evt = this.allEventMainPageInfo[id];
        if (evt.title.toLowerCase().includes(this.keyword.toLowerCase()))
          result.push(evt);
      }

      if (!result.length) {
        this.showDialog({
          title: this.$t("no_match_compaign_title"),
          content: this.$t("no_match_compaign_desp"),
          buttons: [
            {
              text: this.$t("got_it"),
              action: () => {},
            },
          ],
        });

        return;
      }

      this.setAllEvent(this.allEventMainPageInfo);
      this.$router
        .push({
          name: "SearchResult",
          params: { keyword: this.keyword },
        })
        .catch(() => {});
    },
    toCampaign(index, campaign) {
      if (this.$refs.splide.index === index) {
        this.$router
          .push({
            name: "Activity",
            params: { id: campaign.event_id },
          })
          .catch(() => {});
      }
    },
    toNews(announcement) {
      this.$router
        .push({
          name: "News",
          params: { id: announcement.news_id },
        })
        .catch(() => {});
    },
    toNewsList() {
      this.$router.push({ name: "NewsList" }).catch(() => {});
    },
    toActivityList() {
      this.$router
        .push({
          name: "ActivityList",
          params: { type: this.tabSelect === 1 ? "top" : "comming_soon" },
        })
        .catch(() => {});
    },
    renderEventList(name, list, events) {
      this[name] = list.reduce((accr, value) => {
        let event = events.find((e) => e.id === value);
        if (event) accr.push(event);
        return accr;
      }, []);
    },
  },
  async beforeMount() {
    const { data } = await getMainEvents();
    if (Number(data && data.errCode) === 999) {
      this.loadingCampaignsFinish = true;
      this.loadingNewsFinish = true;
      redirectToIndex("index-main-events-errCode-999");
      return;
    }
    let events = [];
    this.allEventMainPageInfo = data.allEventMainPageInfo || {};
    for (var id in this.allEventMainPageInfo) {
      let value = this.allEventMainPageInfo[id];
      events.push({
        id: id,
        event_id: id,
        timeIndex: !data.allEventMainPageInfo[id].exposeStart
          ? 0
          : new Date(data.allEventMainPageInfo[id].exposeStart).valueOf(), // for sorting
        ...data.allEventMainPageInfo[id],
      });
    }
    events.sort((a, b) => {
      return b.timeIndex - a.timeIndex;
    });

    this.commingSoonCampaigns = events;

    this.renderEventList("bannerCampaigns", data.bannerEventId || [], events);
    this.renderEventList("topCampaigns", data.hotEventId || [], events);

    this.splideComponentKey += 1;
    this.loadingCampaignsFinish = true;

    const { data: resNews } = await getNews();
    if (Number(resNews && resNews.errCode) === 999) {
      this.loadingNewsFinish = true;
      redirectToIndex("index-news-errCode-999");
      return;
    }
    let sortedNews = (resNews.sortedNewsList || []).map((n) => {
      let news = resNews.news.find((ne) => ne.news_id === n);
      return news;
    });
    this.news = sortedNews.reduce((accr, news, index) => {
      let dt = new Date();
      let start = new Date(news.exposeStart);
      let end = new Date(news.exposeEnd);
      if (
        news.exposeStart &&
        news.exposeEnd &&
        start.valueOf() <= dt.valueOf() &&
        end.valueOf() >= dt.valueOf()
      ) {
        accr.push(news);
      }
      return accr;
    }, []);
    this.loadingNewsFinish = true;
  },
  mounted() {
    this.$store.dispatch("setOverlayLoading", false);
  },
};
</script>

<style lang="scss" scoped>
.splide__slide {
  border-radius: $radiusMobile;
  transform-origin: 50% 50%;

  .image-block {
    position: relative;
    width: 343px;
    height: 214px;
    overflow: hidden;
    border-radius: $radiusMobile;
    transition: transform 0.2s ease;

    img {
      position: absolute;
      width: auto;
      height: 100%;
      top: -100%;
      bottom: -100%;
      left: -100%;
      right: -100%;
      margin: auto;
      border-radius: $radiusMobile;
    }

    @media screen and (min-width: 801px) {
      width: 800px;
      height: 500px;
    }

    @media screen and (min-width: 600px) and (max-width: 800px) {
      width: 600px;
      height: 375px;
    }
  }

  &:not(.is-active) > .image-block {
    transform: scale(0.92);
    opacity: 0.65;
  }

  &.is-active {
    cursor: pointer;

    > .image-block {
      transform: scale(1);
      opacity: 1;
    }
  }
}

::v-deep .splide__arrow {
  @media screen and (min-width: 960px) {
    width: 4rem !important;
    height: 4rem !important;
  }
}

::v-deep .splide__pagination {
  padding: 0 !important;
}

@media screen and (max-width: 768px) {
  .announcement-item {
    display: flex;
    justify-content: space-between;

    > span:first-child {
      display: block;
      max-height: 2.8em;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      text-overflow: ellipsis;
    }
  }
}

.cus-tab {
  width: 50%;
  position: relative;
  z-index: 2;
  line-height: 3;
  text-align: center;
  font-weight: bold;
  color: #444444;

  &.left-tab {
    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      width: 102%;
      outline: 1px solid transparent;
      border-radius: 12px 12px 0 0;
      background: white;
      content: "";
      -webkit-transform: perspective(5px) rotateX(0.93deg) translateZ(-1px);
      transform: perspective(8px) rotateX(1.1deg) translateZ(-1px);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      box-shadow: -2px -2px 6px 0px rgb(0 0 0 / 9%);
    }
  }

  &.right-tab {
    &::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: auto;
      z-index: -1;
      width: 102%;
      outline: 1px solid transparent;
      border-radius: 12px 12px 0 0;
      background: white;
      content: "";
      -webkit-transform: perspective(5px) rotateX(0.93deg) translateZ(-1px);
      transform: perspective(8px) rotateX(1.1deg) translateZ(-1px);
      -webkit-transform-origin: 100% 0;
      transform-origin: 100% 0;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      box-shadow: 2px -2px 6px 0px rgb(0 0 0 / 9%);
    }
  }

  &.inactive {
    z-index: 0;
    font-weight: 400;
  }
}

.inactive::before {
  background: $grey-lighten-1 !important;
  box-shadow: inset 0 -3px 3px rgb(0 0 0 / 5%) !important;
}

.inactive::after {
  background: $grey-lighten-1 !important;
  box-shadow: inset 0 -3px 3px rgb(0 0 0 / 5%) !important;
}

.tab-content {
  position: relative;
  top: -1px;
  background: white;
  border-radius: 0 0 $radiusDesktop $radiusDesktop;
  box-shadow: 0px 7px 7px 1px rgb(0 0 0 / 9%);

  @media screen and (max-width: 600px) {
    border-radius: 0 0 $radiusMobile $radiusMobile;
  }
}

.announcement-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.v-btn {
  font-weight: bold;
}

.v-btn--outlined {
  border: 2px solid currentColor !important;
}

@media screen and (max-width: 600px) {
  .border-radius-rwd {
    border-radius: $radiusMobile;
  }

  .tab-content {
    border-radius: 0 0 $radiusMobile $radiusMobile;
  }

  .cus-tab {
    &.left-tab {
      &::after {
        border-radius: $radiusMobile $radiusMobile 0 0;
      }
    }

    &.right-tab {
      &::before {
        border-radius: $radiusMobile $radiusMobile 0 0;
      }
    }
  }
}

@media only screen and (min-width: 600px) and (max-width: 960px) {
  .border-radius-rwd {
    border-radius: $radiusDesktop;
  }

  .tab-content {
    border-radius: 0 0 $radiusDesktop $radiusDesktop;
  }

  .cus-tab {
    &.left-tab {
      &::after {
        border-radius: $radiusDesktop $radiusDesktop 0 0;
      }
    }

    &.right-tab {
      &::before {
        border-radius: $radiusDesktop $radiusDesktop 0 0;
      }
    }
  }
}

.search-input {
  border-radius: 4px !important;
}
</style>
